export const FETCH_SHIPMENT_FEES_DETAILS_SUCCESS = "FETCH_SHIPMENT_FEES_DETAILS_SUCCESS";
export const FETCH_SHIPMENT_FEES_DETAILS_REQUEST = "FETCH_SHIPMENT_FEES_DETAILS_REQUEST";
export const FETCH_SHIPMENT_FEES_DETAILS_FAILURE = "FETCH_SHIPMENT_FEES_DETAILS_FAILURE";
export const FETCH_SHIPMENT_FEES_DETAILS_REST = "FETCH_SHIPMENT_FEES_DETAILS_REST";
export const fetchShipmentFeesDetailsSuccess = (payload) => ({
    type: FETCH_SHIPMENT_FEES_DETAILS_SUCCESS,
    payload,
});
export const fetchShipmentFeesDetailsRequest = (payload) => ({
    type: FETCH_SHIPMENT_FEES_DETAILS_REQUEST,
    payload,
});
export const fetchShipmentFeesDetailsFailure = (payload) => ({
    type: FETCH_SHIPMENT_FEES_DETAILS_FAILURE,
    payload,
});
export const fetchShipmentFeesDetailsRest = () => ({
    type: FETCH_SHIPMENT_FEES_DETAILS_REST,
});
